import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Coordinate from '../geom/Coordinate';
import Polygon from '../geom/Polygon';
import Double from '../../../../java/lang/Double';
import GeometryCollection from '../geom/GeometryCollection';
import ArrayList from '../../../../java/util/ArrayList';
import Comparator from '../../../../java/util/Comparator';
import Assert from '../util/Assert';
var InteriorPointArea = /*#__PURE__*/function () {
  function InteriorPointArea() {
    _classCallCheck(this, InteriorPointArea);
    InteriorPointArea.constructor_.apply(this, arguments);
  }
  _createClass(InteriorPointArea, [{
    key: "getInteriorPoint",
    value: function getInteriorPoint() {
      return this._interiorPoint;
    }
  }, {
    key: "process",
    value: function process(geom) {
      if (geom.isEmpty()) return null;
      if (geom instanceof Polygon) {
        this.processPolygon(geom);
      } else if (geom instanceof GeometryCollection) {
        var gc = geom;
        for (var i = 0; i < gc.getNumGeometries(); i++) this.process(gc.getGeometryN(i));
      }
    }
  }, {
    key: "processPolygon",
    value: function processPolygon(polygon) {
      var intPtPoly = new InteriorPointPolygon(polygon);
      intPtPoly.process();
      var width = intPtPoly.getWidth();
      if (width > this._maxWidth) {
        this._maxWidth = width;
        this._interiorPoint = intPtPoly.getInteriorPoint();
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._interiorPoint = null;
      this._maxWidth = -1;
      var g = arguments[0];
      this.process(g);
    }
  }, {
    key: "getInteriorPoint",
    value: function getInteriorPoint(geom) {
      var intPt = new InteriorPointArea(geom);
      return intPt.getInteriorPoint();
    }
  }, {
    key: "avg",
    value: function avg(a, b) {
      return (a + b) / 2.0;
    }
  }]);
  return InteriorPointArea;
}();
export { InteriorPointArea as default };
var InteriorPointPolygon = /*#__PURE__*/function () {
  function InteriorPointPolygon() {
    _classCallCheck(this, InteriorPointPolygon);
    InteriorPointPolygon.constructor_.apply(this, arguments);
  }
  _createClass(InteriorPointPolygon, [{
    key: "findBestMidpoint",
    value: function findBestMidpoint(crossings) {
      if (crossings.size() === 0) return null;
      Assert.isTrue(0 === crossings.size() % 2, 'Interior Point robustness failure: odd number of scanline crossings');
      crossings.sort(new DoubleComparator());
      for (var i = 0; i < crossings.size(); i += 2) {
        var x1 = crossings.get(i);
        var x2 = crossings.get(i + 1);
        var width = x2 - x1;
        if (width > this._interiorSectionWidth) {
          this._interiorSectionWidth = width;
          var interiorPointX = InteriorPointArea.avg(x1, x2);
          this._interiorPoint = new Coordinate(interiorPointX, this._interiorPointY);
        }
      }
    }
  }, {
    key: "process",
    value: function process() {
      if (this._polygon.isEmpty()) return null;
      this._interiorPoint = new Coordinate(this._polygon.getCoordinate());
      var crossings = new ArrayList();
      this.scanRing(this._polygon.getExteriorRing(), crossings);
      for (var i = 0; i < this._polygon.getNumInteriorRing(); i++) this.scanRing(this._polygon.getInteriorRingN(i), crossings);
      this.findBestMidpoint(crossings);
    }
  }, {
    key: "scanRing",
    value: function scanRing(ring, crossings) {
      if (!InteriorPointPolygon.intersectsHorizontalLine(ring.getEnvelopeInternal(), this._interiorPointY)) return null;
      var seq = ring.getCoordinateSequence();
      for (var i = 1; i < seq.size(); i++) {
        var ptPrev = seq.getCoordinate(i - 1);
        var pt = seq.getCoordinate(i);
        this.addEdgeCrossing(ptPrev, pt, this._interiorPointY, crossings);
      }
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this._interiorSectionWidth;
    }
  }, {
    key: "getInteriorPoint",
    value: function getInteriorPoint() {
      return this._interiorPoint;
    }
  }, {
    key: "addEdgeCrossing",
    value: function addEdgeCrossing(p0, p1, scanY, crossings) {
      if (!InteriorPointPolygon.intersectsHorizontalLine(p0, p1, scanY)) return null;
      if (!InteriorPointPolygon.isEdgeCrossingCounted(p0, p1, scanY)) return null;
      var xInt = InteriorPointPolygon.intersection(p0, p1, scanY);
      crossings.add(xInt);
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._polygon = null;
      this._interiorPointY = null;
      this._interiorSectionWidth = 0.0;
      this._interiorPoint = null;
      var polygon = arguments[0];
      this._polygon = polygon;
      this._interiorPointY = ScanLineYOrdinateFinder.getScanLineY(polygon);
    }
  }, {
    key: "isEdgeCrossingCounted",
    value: function isEdgeCrossingCounted(p0, p1, scanY) {
      var y0 = p0.getY();
      var y1 = p1.getY();
      if (y0 === y1) return false;
      if (y0 === scanY && y1 < scanY) return false;
      if (y1 === scanY && y0 < scanY) return false;
      return true;
    }
  }, {
    key: "intersectsHorizontalLine",
    value: function intersectsHorizontalLine() {
      if (arguments.length === 2) {
        var env = arguments[0],
          y = arguments[1];
        if (y < env.getMinY()) return false;
        if (y > env.getMaxY()) return false;
        return true;
      } else if (arguments.length === 3) {
        var p0 = arguments[0],
          p1 = arguments[1],
          _y = arguments[2];
        if (p0.getY() > _y && p1.getY() > _y) return false;
        if (p0.getY() < _y && p1.getY() < _y) return false;
        return true;
      }
    }
  }, {
    key: "intersection",
    value: function intersection(p0, p1, Y) {
      var x0 = p0.getX();
      var x1 = p1.getX();
      if (x0 === x1) return x0;
      var segDX = x1 - x0;
      var segDY = p1.getY() - p0.getY();
      var m = segDY / segDX;
      var x = x0 + (Y - p0.getY()) / m;
      return x;
    }
  }]);
  return InteriorPointPolygon;
}();
var DoubleComparator = /*#__PURE__*/function () {
  function DoubleComparator() {
    _classCallCheck(this, DoubleComparator);
  }
  _createClass(DoubleComparator, [{
    key: "compare",
    value: function compare(v1, v2) {
      return v1 < v2 ? -1 : v1 > v2 ? +1 : 0;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Comparator];
    }
  }]);
  return DoubleComparator;
}();
InteriorPointPolygon.DoubleComparator = DoubleComparator;
var ScanLineYOrdinateFinder = /*#__PURE__*/function () {
  function ScanLineYOrdinateFinder() {
    _classCallCheck(this, ScanLineYOrdinateFinder);
    ScanLineYOrdinateFinder.constructor_.apply(this, arguments);
  }
  _createClass(ScanLineYOrdinateFinder, [{
    key: "updateInterval",
    value: function updateInterval(y) {
      if (y <= this._centreY) {
        if (y > this._loY) this._loY = y;
      } else if (y > this._centreY) {
        if (y < this._hiY) this._hiY = y;
      }
    }
  }, {
    key: "getScanLineY",
    value: function getScanLineY() {
      this.process(this._poly.getExteriorRing());
      for (var i = 0; i < this._poly.getNumInteriorRing(); i++) this.process(this._poly.getInteriorRingN(i));
      var scanLineY = InteriorPointArea.avg(this._hiY, this._loY);
      return scanLineY;
    }
  }, {
    key: "process",
    value: function process(line) {
      var seq = line.getCoordinateSequence();
      for (var i = 0; i < seq.size(); i++) {
        var y = seq.getY(i);
        this.updateInterval(y);
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._poly = null;
      this._centreY = null;
      this._hiY = Double.MAX_VALUE;
      this._loY = -Double.MAX_VALUE;
      var poly = arguments[0];
      this._poly = poly;
      this._hiY = poly.getEnvelopeInternal().getMaxY();
      this._loY = poly.getEnvelopeInternal().getMinY();
      this._centreY = InteriorPointArea.avg(this._loY, this._hiY);
    }
  }, {
    key: "getScanLineY",
    value: function getScanLineY(poly) {
      var finder = new ScanLineYOrdinateFinder(poly);
      return finder.getScanLineY();
    }
  }]);
  return ScanLineYOrdinateFinder;
}();
InteriorPointArea.InteriorPointPolygon = InteriorPointPolygon;
InteriorPointArea.ScanLineYOrdinateFinder = ScanLineYOrdinateFinder;